import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import Logger from '../../utils/logger';
import NavMenu from '../../components/Dropdown/NavMenu';
import { faTrash, faFileEdit } from '@fortawesome/pro-solid-svg-icons';
import { deleteAction } from '../../actions/actions';

const log = Logger('ActionsItemMenu');

function ActionsItemMenu({
    id,
    deleteItem
}) {
    log.debug('render');

    return <NavMenu
        data={[{
            text: 'Edit',
            icon: faFileEdit,
            link: `/actions/${id}`
        },{
            text: 'Delete',
            icon: faTrash,
            onClick: () => deleteItem(id)
        }]}
    />
}

ActionsItemMenu.propTypes = {
    id: PropTypes.string.isRequired,
    deleteItem: PropTypes.func.isRequired
};

export default connect(
    null,
    {
        deleteItem: deleteAction
    }
)(ActionsItemMenu);